import RegisterBetaModalGenerateCode from "./RegisterBetaModalGenerateCode";

export default RegisterBetaModalGenerateCode;
